import feedWidgetsConditions from '@/utils/widgets/feedWidgetsConditions.js'
const components = {
  relation: 'RelationWidgetInput',
  date: 'DateWidgetInput',
  valuesIn: 'ValuesInWidgetInput'
}

export default class FeedWidgetField {
  title
  value
  conditions
  component
  entityName
  constructor (
    title,
    value,
    type,
    entityName
  ) {
    this.title = title
    this.value = value
    this.conditions = feedWidgetsConditions[type]
    this.component = components[type]
    this.entityName = entityName
  }
}
